import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Divider } from "primereact/divider";
import { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { quoteTransportFormDefault } from "../../../factory/form/form.default";
import { QuotationFormSchema } from "../../../factory/form/form.rule";
import { useQyGetTransportType } from "../../../factory/query/transport-type.query";
import { useQyGetUtilAgeBracket } from "../../../factory/query/util-age-bracket.query";
import { useQyGetUtilTransportLocation } from "../../../factory/query/util-transport-location.query";
import { LabelValue } from "../../../shared/models/label-value.interface";
import DropdownControl from "../../../shared/ui/hook-form/dropdown-control/dropdown-control";
import InputDigitControl from "../../../shared/ui/hook-form/input-digit-control/input-digit-control";
import QuoteTransportChildren from "./quote-transport-children";

type InputFormSchema = QuotationFormSchema;
export default function QuoteTransport() {
  const { control, setValue, getValues, watch } =
    useFormContext<QuotationFormSchema>();
  const [transportTypes, setTransportTypes] = useState<LabelValue[]>([]);
  const [transportLocations, setTransportLocations] = useState<LabelValue[]>(
    []
  );
  const numChildren = watch("numChildren");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "transport",
  });

  // THIS IS THE LOCAL QUERY DECLARATION
  useQyGetTransportType("", 9999, 0, undefined, undefined, true, (response) => {
    const mappedSuggestions = (response?.data || [])
      .map((item) => ({
        label: `${item.name}`,
        value: item.code,
      }))
      .filter((x) => !!x.label);
    // Set the suggestions for the dropdown control
    setTransportTypes(mappedSuggestions);
  });

  useQyGetUtilTransportLocation(
    "",
    9999,
    0,
    undefined,
    undefined,
    true,
    (response) => {
      const mappedSuggestions = (response?.data || [])
        .map((item) => ({
          label: `${item.name}`,
          value: item.code,
        }))
        .filter((x) => !!x.label);
      // Set the suggestions for the dropdown control
      setTransportLocations(mappedSuggestions);
    }
  );


  return (
    <div className="quotation-transport bg-white p-4 rounded shadow my-4">
      <DataTable value={fields} selectionMode="single" className="mb-4">
        <Column
          field="transportType"
          header="Transport Type"
          body={(item, options) => (
            <div>
              <div className="flex justify-end">
                <Button
                  severity="danger"
                  type="button"
                  className="mt-2"
                  onClick={() => remove(options.rowIndex)}
                  icon="pi pi-trash"
                ></Button>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <DropdownControl<InputFormSchema>
                  control={control}
                  name={`transport.${options.rowIndex}.transportType`}
                  label="Transport Type"
                  className="w-full"
                  containerClassName="pb-2"
                  placeholder="Select a transport type"
                  options={transportTypes}
                  onSelect={(value) => {
                    const transportType = transportTypes.find(
                      (type) => type.value === value
                    );
                    setValue(
                      `transport.${options.rowIndex}.transportTypeName`,
                      transportType?.label || ""
                    );
                  }}
                />
                <DropdownControl<InputFormSchema>
                  control={control}
                  name={`transport.${options.rowIndex}.fromLocation`}
                  label="From"
                  className="w-full"
                  containerClassName="pb-2"
                  placeholder="Enter from location"
                  options={transportLocations}
                  onSelect={(value) => {
                    const location = transportLocations.find(
                      (loc) => loc.value === value
                    );
                    setValue(
                      `transport.${options.rowIndex}.fromLocationName`,
                      location?.label || ""
                    );
                  }}
                />
                <DropdownControl<InputFormSchema>
                  control={control}
                  name={`transport.${options.rowIndex}.toLocation`}
                  label="To"
                  className="w-full"
                  containerClassName="pb-2"
                  placeholder="Enter to location"
                  options={transportLocations}
                  onSelect={(value) => {
                    const location = transportLocations.find(
                      (loc) => loc.value === value
                    );
                    setValue(
                      `transport.${options.rowIndex}.toLocationName`,
                      location?.label || ""
                    );
                  }}
                />
                <InputDigitControl<InputFormSchema>
                  control={control}
                  name={`transport.${options.rowIndex}.pricePerPax`}
                  label="Price/Pax"
                  className="w-full"
                  containerClassName="pb-2"
                  placeholder="Enter to price per pax"
                  onValueChange={(value) => {
                    const numPeople = getValues(
                      `transport.${options.rowIndex}.numPeople`
                    );
                    setValue(
                      `transport.${options.rowIndex}.amount`,
                      (value || 0) * (numPeople || 0)
                    );
                  }}
                />
                <InputDigitControl<InputFormSchema>
                  control={control}
                  name={`transport.${options.rowIndex}.numPeople`}
                  label="Pax"
                  className="w-full"
                  containerClassName="pb-2"
                  placeholder="Enter to number of people"
                  onValueChange={(value: number) => {
                    const pricePerPax = getValues(
                      `transport.${options.rowIndex}.pricePerPax`
                    );
                    setValue(
                      `transport.${options.rowIndex}.amount`,
                      (value || 0) * (pricePerPax || 0)
                    );
                  }}
                />
                <InputDigitControl<InputFormSchema>
                  control={control}
                  name={`transport.${options.rowIndex}.amount`}
                  label="Amount"
                  className="w-full"
                  containerClassName="pb-2"
                  placeholder="Enter to amount"
                />
              </div>
              {(numChildren || 0) > 0 && (
                <QuoteTransportChildren rowIndex={options.rowIndex} />
              )}
            </div>
          )}
        ></Column>
        {/* <Column
          field="fromLocation"
          header="From"
          body={(item, options) => (
          )}
        ></Column>
        <Column
          field="toLocation"
          header="To"
          body={(item, options) => (
          )}
        ></Column>
        <Column
          field="pricePerPax"
          header="Price/Pax"
          body={(item, options) => (
          )}
        ></Column>
        <Column
          field="numPeople"
          header="Pax"
          body={(item, options) => (
          )}
        ></Column>
        <Column
          field="amount"
          header="Amount"
          body={(item, options) => (
          )}
        ></Column>
        <Column
          field="actions"
          header="Actions"
          body={(item, options) => (
          )}
        ></Column> */}
      </DataTable>
      <Button type="button" onClick={() => append(quoteTransportFormDefault)}>
        Add Transport
      </Button>
    </div>
  );
}
